module.exports = {
  PLEASE_SELECT: 'Please Select',
  PLEASE_INPUT: 'Please Input',
  NO_MATCH: 'No Match',
  CAL_MONDAY: 'Mon',
  CAL_TUESDAY: 'Tue',
  CAL_WENSDAY: 'Wen',
  CAL_THURSDAY: 'Thu',
  CAL_FRIDAY: 'Fri',
  CAL_SATURDAY: 'Sat',
  CAL_SUNDAY: 'Sun',
  CONFIRM: 'Confirm',
  ALL: 'All',
  UPLOAD: 'Upload',
  DROPDOWN_LIST: 'Dropdown List',
  MULTILEVEL_MENU: 'Multi-level Menu',
  GOTO: 'Goto',
  PAGE_NEXT: 'Next',
  PAGE_PREV: 'Prev',
  CANCEL: 'Cancel',
  NOTICE: 'Notice',
  ITEM_PAGE: '/page',
  TOTAL: 'total',
  ITEMS: 'items',
  PAGE: '',
  FORMAT_ERROR: 'Format Error',
  VALUE_ERROR: 'Value Error',
  LENGTH_ERROR: 'Length Error',
  LOADING: 'Loading',
  NO_DATA: 'No data',
  FILE_TYPE_ERROR: 'TypeError',
  FILE_TOO_LARGE: 'TooLarge',
  RETRY: 'Retry',
  UPLOAD_FILE: 'File',
  DOWNLOAD_FILE: '',
  UPLOAD_FAIL: 'Fail',
  UNKNOWN: 'UNKNOWN',
  REMOVE_CONFIRM: 'Are you sure to remove',
  LIMIT_ERROR: 'the limit should be a number',
  IMAGE_WIDTH_ERROR: 'width error',
  IMAGE_HEIGHT_ERROR: 'height error',
  IMAGE_SCALE_ERROR: 'scale error',
  PLEASE_UPLOAD_ATLEAST: 'Please upload at least',
  UNIT: '',
  FILE: 'file',
  SEARCH: 'search',
  RESET: 'reset',
  FOLD: 'fold',
  UNFOLD: 'unfold',
  JAN: 'Jan',
  FEB: 'Feb',
  MAR: 'Mar',
  APR: 'Apr',
  MAY: 'May',
  JUN: 'Jun',
  JUL: 'Jul',
  AUG: 'Aug',
  SEP: 'Sep',
  OCT: 'Oct',
  NOV: 'Nov',
  DEC: 'Dec',
};



// WEBPACK FOOTER //
// ../src/js/language/en-US.js